export const isFullStatic = false
export const staticPath = "/builds/anny.co/anny-frontend/anny-teams/.nuxt/static-json"
export const publicPath = "https://cdn.anny.eu/add-in-teams/d66c3e0b/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"